import React, { Fragment } from "react";
import Project from "../../shared/Project";
import { createEnDaContent, lang, translateContent } from "../../globals/Translations";
import { TranslatedTerms } from "../../globals/TranslatedTerms";
import { Row } from "../atoms/ProjectCard";
import { ColumnFlexBox } from "../templates/Wrappers";
import CentralInvestorInformation from "../../shared/CentralInvestorInformation";
import { NiceDate } from "../../shared/UIFormatting";



const CentralInvestorInformationElement: React.FC<{ data: CentralInvestorInformation }> = ({ data }) => {
  if (!data) return <></>

  return (
    <ColumnFlexBox>
      <h4 style={{ marginTop: 32 }}>Central investorinformation</h4>
      {Row(NiceDate(data.lastUpdate) + " - " + lang(TranslatedTerms.LATEST_VERSION), <a target="_blank" href={data.documentURL}>{lang(TranslatedTerms.OPEN_DOCUMENT)}</a>, 1)}
      <b style={{ marginTop: 12 }}>{translateContent(createEnDaContent("History", "Historik"))}</b>
      {data.updates.map((update, index) => (
        Row(NiceDate(update.updatedDate) + " - " + update.updateReason, <a target="_blank" href={update.PITDocumentURL}>{lang(TranslatedTerms.OPEN_DOCUMENT)}</a>, index)
      ))}
    </ColumnFlexBox>
  )
}

const DocumentsElement: React.FC<{ project?: Project }> = ({ project }) => {
  if (!project) return <></>

  return (
    <Fragment>
      <ColumnFlexBox>
        {project?.documentation?.projectInformationDocument && <h4>{translateContent(createEnDaContent("Investor Information", "Investorinformation"))}</h4>}
        {project?.documentation?.projectInformationDocument && Row(lang(TranslatedTerms.LATEST_VERSION), <a target="_blank" href={project.documentation.projectInformationDocument}>{lang(TranslatedTerms.OPEN_DOCUMENT)}</a>, 1)}
      </ColumnFlexBox>
      {project?.documentation?.centralInvestorInformation && <CentralInvestorInformationElement data={project.documentation.centralInvestorInformation} />}
      {!project.documentation && <b>{translateContent(createEnDaContent("No documents", "Ingen dokumenter"))}</b>}
    </Fragment>
  )
}

export default DocumentsElement;
